<template>
    <div>
        <BaseEchart :option="option"></BaseEchart>
    </div>
</template>


<script>
import BaseEchart from '@/components/base-echart/base-echart.vue';

export default {
    components: {
        BaseEchart,
    },
    props: {
        echartData: {
            type: Array,
            default: () => ({}),
        },
    },
    computed: {
        option() {
            return {
                tooltip: {
                    trigger: "item",
                },
                legend: {
                    orient: "horizontal",
                    left: "left",
                },
                series: [
                    {
                        name: "分类数据",
                        type: "pie",
                        radius: "50%",
                        data: this.echartData,
                        emphasis: {
                            itemStyle: {
                                shadowBlur: 10,
                                shadowOffsetX: 0,
                                shadowColor: "rgba(0, 0, 0, 0.5)",
                            },
                        },
                    },
                ],
            };
        }
    }
}
</script>